import styled, { css } from 'styled-components'

import FICColors from '../common/FICColors'

export const topOffset = !localStorage.getItem('helpFacebookBannerIsVisible')
  ? 90 + 48
  : 90
export const MainContainer = styled.div<{
  isExternal: boolean
  isMainPage?: boolean
}>`
  margin: 0 !important;
  -webkit-font-smoothing: antialiased;
  font-family: 'Open Sans', sans-serif;
  a{
    color: #0D97D5;
  }
  ul{
    padding: 0;
    margin: 0 0 10px 25px;
  }
  background-color: ${FICColors.white};
  border-radius: 5px;
  overflow: auto;
  height: 100%;
  ${(props) =>
    props.isExternal &&
    css`
      position: absolute;
      width: 100%;
      height: calc(100% - 90px);
      @media (max-width: 425px) {
        height: calc(100% - 57px);
      }
    `};
  ${(props) =>
    props.isMainPage &&
    props.isExternal &&
    css`
      top: 0;
    `};
  @supports (-ms-ime-align: auto) {
    & {
      border-radius: 7px;
    }
  }
  .embeddedArticle {
    max-width: 800px;
  }
  .embeddedSection {
    max-width: 800px;
  }
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(51, 51, 51, 0.08);
`

export const ChatTitle = styled.h3`
  font-weight: normal;
`

export const ChatContainer = styled.div`
  margin: 50px auto;
  box-sizing: border-box;
  text-align: center;
  padding-left: 12.5px;
  padding-right: 12.5px;

  /*.fic-text-button {
    background-color: ${FICColors.white};
    color: ${FICColors.defaultBlue};
    border: 2px solid ${FICColors.defaultBlue};
    font-size: 16px !important;
    text-transform: none;
    padding: 15px !important;
    &:hover {
      color: ${FICColors.white};
      background-color: ${FICColors.defaultBlue};
    }
  }*/
  h3 {
    margin: 25px 0;
    font-size: 20px;
  }
  .averageResponseTime {
    box-sizing: border-box;
    height: auto;
    width: 640px;
    max-width: 100%;
    border: 1px solid rgba(255, 141, 45, 0.32);
    border-radius: 4px;
    background-color: rgba(255, 141, 45, 0.24);
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
    margin: 30px auto;
    color: #ff8d2d;
    font-size: 16px;
    padding: 13px;
    line-height: 23px;
    span {
      display: table-cell;
      width: 100%;
    }
    span.iconContainer {
      display: table-cell;
      vertical-align: middle;
      padding-right: 8px;
      font-size: 23px;
      width: auto !important;
    }
  }
`

export const ElementNotFoundContainer = styled.div`
  max-width: 940px;
  margin: 0 auto;
  padding: 24px 0;
  font-size: 16px;
  text-align: center;
  
  a {
    color: ${FICColors.white};
  }
`

export const PrivacyMessageContainer = styled.div`
  max-width: 640px;
  color: #6f7e86;
  font-size: 10px;
  margin: 0 auto 40px;
  line-height: 15px;
  @media (max-width: 425px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const EditorToggle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
